import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { CalcSettingsCreateContainer } from "./containers/CalcSettingsCreateContainer";
import { CalcSettingsDetailContainer } from "./containers/CalcSettingsDetailContainer";
import { CalcSettingsListContainer } from "./containers/CalcSettingsListContainer";
import { ADMIN_CALC_ROUTE_PATHS } from "./paths";

const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<CalcSettingsListContainer />}
          permissions={[
            Permission.ADMIN_MTPL_CALCULATORS,
            Permission.ADMIN_CRASH_CALCULATORS,
            Permission.ADMIN_REALTY_CALCULATORS,
            Permission.ADMIN_TRAVEL_CALCULATORS,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={ADMIN_CALC_ROUTE_PATHS.create.path}
      element={
        <PageWithPermission
          component={<CalcSettingsCreateContainer />}
          permissions={[
            Permission.ADMIN_MTPL_CALCULATORS,
            Permission.ADMIN_CRASH_CALCULATORS,
            Permission.ADMIN_REALTY_CALCULATORS,
            Permission.ADMIN_TRAVEL_CALCULATORS,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={ADMIN_CALC_ROUTE_PATHS.detail.path}
      element={
        <PageWithPermission
          component={<CalcSettingsDetailContainer />}
          permissions={[
            Permission.ADMIN_MTPL_CALCULATORS,
            Permission.ADMIN_CRASH_CALCULATORS,
            Permission.ADMIN_REALTY_CALCULATORS,
            Permission.ADMIN_TRAVEL_CALCULATORS,
          ]}
          anyPermission
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
